(function () {
  var THRESHOLD = 3;

  function renderAlert(count) {
    var el = document.getElementById('ecoreina-shipping-alert');
    if (!el) return;
    if (count <= 0) { el.style.display = 'none'; return; }
    el.style.display = 'block';

    var pct = Math.min((count / THRESHOLD) * 100, 100);
    var isSuccess = count >= THRESHOLD;
    var needed = THRESHOLD - count;
    var word = needed === 1 ? 'falta' : 'faltan';
    var unit = needed === 1 ? 'producto' : 'productos';

    var textHtml = isSuccess
      ? '<span class="ecoreina-shipping-alert__text ecoreina-shipping-alert__text--success">🎉 ¡Ya has conseguido el <strong>ENVÍO GRATIS</strong>!</span>'
      : '<span class="ecoreina-shipping-alert__text">Te ' + word + ' <strong>' + needed + ' ' + unit + '</strong> para <strong>ENVÍO GRATIS</strong></span>';

    el.innerHTML =
      textHtml +
      '<div class="ecoreina-shipping-alert__bar-wrap">' +
        '<div class="ecoreina-shipping-alert__bar' + (isSuccess ? ' ecoreina-shipping-alert__bar--success' : '') + '" style="width:' + pct + '%"></div>' +
      '</div>';
  }

  function fetchAndRender() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderAlert(cart.item_count); })
      .catch(function () {});
  }

  fetchAndRender();

  var bodyObserver = new MutationObserver(function () {
    var el = document.getElementById('ecoreina-shipping-alert');
    if (el) fetchAndRender();
  });
  bodyObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden', 'open'] });

  ['cart:updated', 'cart:refresh', 'theme:cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, fetchAndRender);
  });

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.cart-item') ||
      e.target.closest('[data-cart-item]') ||
      e.target.closest('.quantity-down') ||
      e.target.closest('.quantity-up')
    ) {
      setTimeout(fetchAndRender, 600);
    }
  });

  setInterval(function () {
    var drawer = document.querySelector('.cart-drawer[open], .cart-drawer.is-open, .cart-drawer.active');
    if (drawer) fetchAndRender();
  }, 2000);
})();
